export enum language {
    bagegametext_1 = "FIRST TEXT DE",
    bagegametext_2 = "SECOND TEXT DE",
    bagegametext_4 = "DE:If a single Treasure Wild, Dragon.",

}
